import currencyFormatter from "currency-formatter";

export const formatMoney = (value: number | string) => {
  return currencyFormatter.format(value as number, { code: "CHF" });
};
